// @mui
import { Card } from '@mui/material';
// components
import { ChatSidebar, ChatWindow } from './components/index';
import useUserConversations from './hooks/useUserConversations';

export default function Chat() {
  useUserConversations();
  return (
    <Card sx={{ height: '72vh', display: 'flex' }}>
      <ChatSidebar />
      <ChatWindow />
    </Card>
  );
}
